import { useTheme } from "hooks/useTheme";
import React from "react";
import { isColorDark } from "utils/utilityFunctions";

function PoweredBy() {
  const theme = useTheme();
  return (
    <div
      style={{
        fontSize: 12,
        color: isColorDark(theme.main) ? "#ACACAC" : "black",
        marginBottom: 10,
        marginTop: 10,
      }}
    >
      Powered by DentistFind
    </div>
  );
}

export default PoweredBy;
